const style = (theme) => {
  const output = {
    root: {
      position: 'relative',
      transition: `padding-top 1s ${theme.easings['power4.out']}`,
      paddingBottom: (props) => props.heightPercent,
      overflow: 'hidden',
      '&::before': {
        content: (props) => (props.top ? '""' : 'none'),
        display: 'block',
        width: '100%',
        height: '20vh',
        position: 'absolute',
        zIndex: 2,
        top: 0,
        left: 0,
        background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.8) 0, rgba(0, 0, 0, 0) 80%)',
      },
      '& img': {
        position: 'absolute',
        zIndex: 1,
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        objectFit: 'cover',
        fontFamily: "'object-fit: cover;'",
      },
      '& video': {
        position: 'absolute',
        zIndex: 1,
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        objectFit: 'cover',
        fontFamily: "'object-fit: cover;'",
      },
    },
    text: {},
    title: {},
    rootViewportHeight: {
      height: '100vh',
      fallback: {
        height: 'calc(var(--vh) * 100)',
      },
      paddingBottom: '0 !important',
      '& $container': {
        paddingLeft: 0,
      },
    },
    wrapper: {
      extend: theme.wrapper,
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 2,
      '& h1': {
        lineHeight: 1,
        fontSize: 40,
        color: 'currentColor',
      },
      '& p': {
        lineHeight: 1.2,
        fontSize: 13,
        color: 'currentColor',
        '& .center': {
          color: theme.colors[3],
        },
        '& .green': {
          color: theme.colors[8],
        },
      },
    },
    container: {
      paddingLeft: '8.3vw',
    },
    rootMinimize: {
      paddingTop: (props) => `${props.headerHeight}px`,
      height: 'auto',
      boxShadow: `0px 0px 10px 1px ${theme.getRgba(theme.colors[0], 0.1)}`,
      '& $wrapper': {
        position: 'relative',
        transform: 'none',
        top: 'unset',
      },
      '& $title': {
        display: 'none',
      },
      '& $text': {
        display: 'none',
      },
    },
  }

  /*------------------------------
  MODEL_DIR
  ------------------------------*/
  output[theme.mediaInverse.md] = {}

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    root: {
      position: 'relative',
      paddingBottom: (props) => (props.locator ? '130% !important' : ''),
    },
    container: {
      paddingLeft: 0,
    },
    wrapper: {
      width: '100%',
      top: 'unset',
      bottom: 50,
      transform: 'none',
      '& h1': {
        fontSize: 30,
      },
    },
    rootViewportHeight: {
      '& $wrapper': {
        top: '50%',
        bottom: 'unset',
        transform: 'translateY(-50%)',
        '& h1': {
          fontSize: 25,
          textAlign: 'center',
        },
        '& p': {
          textAlign: 'center',
          fontSize: 12,
        },
      },
    },
    rootMinimize: {
      paddingBottom: () => '0 !important',
      '& $wrapper': {
        position: 'relative',
        transform: 'none',
        top: 'unset',
        bottom: 'unset',
      },
    },
  }

  return output
}
export default style
